// Roadmap 1b.8 (A1-62) — the reverse-charge card states the rule each
// country actually applies, once per country, instead of one sentence for
// all 27. The backend works the rule out (engine/art194_election.describe_rule,
// from the cited per-country research) and sends it on each row as
// `rc_rule`; this only puts it into words. Shown once per country at the top
// of the card, not on every row (operator 2026-10-11: rows had too much
// repeated text).
import React from "react";
import { useTranslation } from "react-i18next";
import { countryName } from "../../lib/countries";

const ruleKey = (r) =>
  [r.country, r.test, r.supplier_not_registered, r.non_eu_supplier_must_register].join("|");

export const uniqueRules = (rows) => {
  const seen = new Map();
  for (const row of rows || []) {
    const r = row?.rc_rule;
    if (!r) continue;
    const k = ruleKey(r);
    const prev = seen.get(k);
    seen.set(k, { rule: r, count: (prev?.count || 0) + 1 });
  }
  return [...seen.values()].sort((a, b) => a.rule.country.localeCompare(b.rule.country));
};

export const RcRuleSummary = ({ rows }) => {
  const { t } = useTranslation();
  const rules = uniqueRules(rows);
  if (!rules.length) return null;
  return (
    <ul data-testid="rc-rule-summary" className="text-xs text-slate-700 dark:text-slate-300 space-y-1 mb-2">
      {rules.map(({ rule, count }) => {
        const country = countryName(rule.country) || rule.country;
        const parts = [t(`ui.rc_rule.test_${rule.test.toLowerCase()}`, { country })];
        if (rule.supplier_not_registered) parts.push(t("ui.rc_rule.supplier_not_registered", { country }));
        if (rule.non_eu_supplier_must_register) parts.push(t("ui.rc_rule.non_eu_supplier", { country }));
        return (
          <li key={ruleKey(rule)} data-testid={`rc-rule-${rule.country}`}>
            <span className="font-medium" translate="no">{country}</span>
            {" "}({t("ui.rc_rule.rows", { count })}): {parts.join(" ")}
          </li>
        );
      })}
    </ul>
  );
};
